import { writable } from 'svelte/store';
import { sound } from './sound';

export type ToastTone = 'info' | 'success' | 'warning' | 'error' | 'neutral';

export type Toast = {
	id: number;
	message: string;
	tone: ToastTone;
	/** Optional image (e.g. a badge SVG) shown in place of the tone icon. */
	icon?: string;
};

export const toasts = writable<Toast[]>([]);

let nextToastId = 1;
let currentTimeout: ReturnType<typeof setTimeout> | null = null;

export function showToast(
	message: string,
	tone: ToastTone = 'info',
	duration = 2200,
	icon?: string
) {
	const id = nextToastId;
	nextToastId += 1;

	if (currentTimeout !== null) clearTimeout(currentTimeout);
	toasts.set([{ id, message, tone, icon }]);
	sound.toast();

	currentTimeout = setTimeout(() => {
		currentTimeout = null;
		dismissToast(id);
	}, duration);

	return id;
}

export function dismissToast(id: number) {
	toasts.update((currentToasts) => currentToasts.filter((toast) => toast.id !== id));
}
